import { Component, OnInit } from '@angular/core';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-corporate-training-solutions',
  templateUrl: './corporate-training-solutions.component.html',
  styleUrls: ['./corporate-training-solutions.component.css']
})
export class CorporateTrainingSolutionsComponent implements OnInit {

  faCheckCircle = faCheckCircle;
  constructor() { }

  ngOnInit(): void {
  }

}
